/**
 * @author Raghav Prabhu
 */
import service from '../Common/'
import constants from '../../../settings/shared/constants'


function PostConnector(ConnectData) {
    let jwtToken = localStorage.getItem('accessToken');
    let headers = {'Content-Type':'application/json', 'Authorization':'Bearer '+jwtToken}
        return service({
            url: constants.api.connector.postConnector,
            method: 'POST',
            headers: headers,
            data:  ConnectData
        }); 
 }

 function UpdateConnector(upateData,id) {
    let jwtToken = localStorage.getItem('accessToken');
    let headers = {'Content-Type':'application/json', 'Authorization':'Bearer '+jwtToken}
        return service({
            url: constants.api.connector.updateConnector+id,
            method: 'PUT',
            headers: headers,
            data:  upateData
        }); 
 }


 function getAllConnectorByType(connectorType) {
    let jwtToken = localStorage.getItem('accessToken');
    let headers = {'Content-Type':'application/json', 'Authorization':'Bearer '+jwtToken}
        return service({
            url: constants.api.connector.getConnectorsByType+"?type="+connectorType,
            method: 'GET',
            headers: headers,
            data:  ''
        }); 
 }

 function getConnectorById(id) {
    let jwtToken = localStorage.getItem('accessToken');
    let headers = {'Content-Type':'application/json', 'Authorization':'Bearer '+jwtToken}
        return service({
            url: constants.api.connector.getConnectorsById+id,
            method: 'GET',
            headers: headers,
            data:  ''
        }); 
 }

 function getAllConnectors() {
    let jwtToken = localStorage.getItem('accessToken');
    let headers = {'Content-Type':'application/json', 'Authorization':'Bearer '+jwtToken}
        return service({
            url: constants.api.connector.getAllConnector,
            method: 'GET',
            headers: headers,
            data:  ''
        }); 
 }

 function getAllConnectorsByList() {
    let jwtToken = localStorage.getItem('accessToken');
    let headers = {'Content-Type':'application/json', 'Authorization':'Bearer '+jwtToken}
        return service({
            url: constants.api.connector.getAllConnectors,
            method: 'GET',
            headers: headers,
            data:  ''
        }); 
 }

 function removeConnector(id) {
    let jwtToken = localStorage.getItem('accessToken');
    let headers = {'Content-Type':'application/json', 'Authorization':'Bearer '+jwtToken}
        return service({
            url: constants.api.connector.removeConnector+id,
            method: 'DELETE',
            headers: headers,
            data:  ''
        }); 
 }

 function getAllConnectorsByGroupName(name) {
    let jwtToken = localStorage.getItem('accessToken');
    let headers = {'Content-Type':'application/json', 'Authorization':'Bearer '+jwtToken}
        return service({
            url: constants.api.connector.getConnectorsByName+"?groupName="+name,
            method: 'GET',
            headers: headers,
            data:  ''
        }); 
 }
 function getConnectorbaseById(id) {
    let jwtToken = localStorage.getItem('accessToken');
    let headers = {'Content-Type':'application/json', 'Authorization':'Bearer '+jwtToken}
        return service({
            url: constants.api.connector.getConnectorsbaseById+id,
            method: 'GET',
            headers: headers,
            data:  ''
        }); 
 }

 function getGrpName() {
    let jwtToken = localStorage.getItem('accessToken');
    let headers = {'Content-Type':'application/json', 'Authorization':'Bearer '+jwtToken}
        return service({
            url: constants.api.connector.getGroupName,
            method: 'GET',
            headers: headers,
            data:  ''
        }); 
 }
 function getDynamicFields(name) {
    let jwtToken = localStorage.getItem('accessToken');
    let headers = {'Content-Type':'application/json', 'Authorization':'Bearer '+jwtToken}
        return service({
            url: constants.api.connector.getdynamicFields+"?type="+name,
            method: 'GET',
            headers: headers,
            data:  ''
        }); 
 }
 
 function getAllConnectorBase() {
    let jwtToken = localStorage.getItem('accessToken');
    let headers = {'Content-Type':'application/json', 'Authorization':'Bearer '+jwtToken}
        return service({
            url: constants.api.connector.getAllConnectorBase,
            method: 'GET',
            headers: headers,
            data:  ''
        }); 
 }
//To export authentication function
const ConnectorService = {
    PostConnector,getAllConnectorByType,removeConnector,getConnectorById,
    getAllConnectors,getAllConnectorsByList,UpdateConnector,getAllConnectorsByGroupName,getConnectorbaseById,getGrpName,getDynamicFields,getAllConnectorBase
}

export default ConnectorService;
